import React from 'react';

import { DemoUIState } from '@/model/demo/types';
import { ReceiverPageView } from '@/pages/withdrawal/pages/ReceiverPage/component';

export const ReceiverPage: React.FC = () => (
  <ReceiverPageView backPath={`${DemoUIState.SEND_OPTIONS}`} shortPhoneMask />
);

export default ReceiverPage;
